import { render, staticRenderFns } from "./MigrationTools.vue?vue&type=template&id=687fb4b7"
import script from "./MigrationTools.vue?vue&type=script&lang=js"
export * from "./MigrationTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports